import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { Typography, TypographyColors, TypographyVariants } from '@lyearn/ui';
import * as User from '@/components/User';
import { UserFragment } from '@/graphql/fragments/generated/User';

export interface UserDetailsOverrides {
  Email?: {
    Typography?: {
      variant?: TypographyVariants;
      color?: TypographyColors;
    };
  };
  Name?: {
    Typography?: {
      variant?: TypographyVariants;
      color?: TypographyColors;
    };
  };
  Icon?: {
    className?: string;
    size?: number;
  };
}

function UserDetail({
  user,
  showEmail = true,
  endAdornment,
  className,
  isSelected,
  overrides,
  isArchived,
}: {
  user: UserFragment;
  showEmail?: boolean;
  endAdornment?: React.ReactNode;
  className?: string;
  isSelected?: boolean;
  overrides?: UserDetailsOverrides;
  isArchived?: boolean;
}) {
  const userNameColor = isSelected ? 'text-text-primary' : 'text-text-secondary';

  return (
    <User.Provider
      alignItems="center"
      className={cn(className ?? 'mb-2 py-10 px-12', 'flex w-full')}
      user={user}>
      <User.ProfilePicture
        className={overrides?.Icon?.className ?? (showEmail ? 'me-16' : 'me-12')}
        size={overrides?.Icon?.size ?? (showEmail ? 36 : 22)}
      />
      <Stack alignItems="center" className="flex-grow overflow-hidden" justifyContent="between">
        <Stack className="w-full overflow-hidden" direction="col">
          {isArchived ? (
            <Typography
              className="truncate"
              color={'text-text-secondary'}
              variant={'body-short-02'}>
              Archived
            </Typography>
          ) : (
            <User.Name
              className="truncate"
              color={overrides?.Name?.Typography?.color ?? (showEmail ? undefined : userNameColor)}
              variant={overrides?.Name?.Typography?.variant}
            />
          )}
          {showEmail || !user.name ? (
            <User.UniqueId
              className="mt-2 truncate"
              color={isSelected && !user.name ? 'text-text-primary' : undefined}
              variant={overrides?.Email?.Typography?.variant}
            />
          ) : null}
        </Stack>
        {endAdornment}
      </Stack>
    </User.Provider>
  );
}

export default UserDetail;
